import styles from "../list.module.css";
import { ArrowLeft } from "react-feather";
import { useState } from "react";
import Loader from "../../../components/Loader";
import Step2DriverCard from "./Step2DriverCard";

const Step3 = ({ selectedDriverList, routes, selectedRows, setCurrentStep, setSelectedDriverList }) => {
  const [loading, setLoading] = useState(false);

  return (<>
    {loading && <Loader />}
    <div className={`${styles.MainDiv}`}>
      <div>
        <div className={`${styles.DriverNextPreBuSec}`}>
          <button onClick={(e) => setCurrentStep(2)}>
            <ArrowLeft /> &nbsp; Back
          </button>
        </div>
        {selectedDriverList?.map((item) => {
          return (<Step2DriverCard item={item} routes={routes} selectedDriverList={selectedDriverList} setLoading={setLoading.bind(this)} setSelectedDriverList={setSelectedDriverList.bind(this)} />);
        })}
      </div>
    </div>
  </>);
};

export default Step3;